"use client"

import { requestPasswordReset, resetPassword } from "@lib/data/customer"
import ErrorMessage from "@modules/checkout/components/error-message"
import { SubmitButton } from "@modules/checkout/components/submit-button"
import Input from "@modules/common/components/input"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { useActionState } from "react"

/** "Forgot password" form: asks for the email and sends the reset link. */
export function ForgotPassword({ onBack }: { onBack: () => void }) {
  const [state, formAction] = useActionState(requestPasswordReset, null)

  return (
    <div className="max-w-sm w-full flex flex-col items-center" data-testid="forgot-password">
      <h1 className="text-large-semi uppercase mb-6">Restablecer contrasena</h1>
      {state?.sent ? (
        <p className="text-center text-base-regular mb-6" data-testid="forgot-password-sent">
          Si existe una cuenta con <strong>{state.email}</strong>, recibiras un email con un enlace
          para crear una nueva contrasena. Caduca en 15 minutos.
        </p>
      ) : (
        <form className="w-full flex flex-col gap-y-2" action={formAction}>
          <p className="text-center text-base-regular mb-4">
            Te enviaremos un enlace para crear una nueva contrasena.
          </p>
          <Input label="Correo electronico" name="email" type="email" autoComplete="email" required />
          <SubmitButton className="w-full mt-4">Enviar enlace</SubmitButton>
        </form>
      )}
      <button onClick={onBack} className="underline text-small-regular mt-6">
        Volver a iniciar sesion
      </button>
    </div>
  )
}

/** New password form reached from the email link. */
export function ResetPasswordForm({ token, email }: { token: string; email: string }) {
  const [state, formAction] = useActionState(resetPassword, null)

  if (state?.ok) {
    return (
      <div className="max-w-sm w-full flex flex-col items-center gap-y-4 text-center">
        <p className="text-base-regular">Tu contrasena se ha cambiado.</p>
        <LocalizedClientLink href="/account" className="zl-btn">
          Iniciar sesion
        </LocalizedClientLink>
      </div>
    )
  }

  return (
    <form className="max-w-sm w-full flex flex-col gap-y-2" action={formAction} data-testid="reset-password-form">
      <h1 className="text-large-semi uppercase mb-4 text-center">Nueva contrasena</h1>
      <input type="hidden" name="token" value={token} />
      <input type="hidden" name="email" value={email} />
      <Input label="Nueva contrasena" name="password" type="password" autoComplete="new-password" required />
      <Input label="Repite la contrasena" name="confirm" type="password" autoComplete="new-password" required />
      <ErrorMessage error={state?.error ?? null} data-testid="reset-password-error" />
      <SubmitButton className="w-full mt-4">Guardar contrasena</SubmitButton>
    </form>
  )
}
